/*
 *
 * User reducer
 *
 */
import { fromJS, List } from 'immutable'
import { UserRoleRecord } from 'records'

import {
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_ERROR,
  CHANGE_PASSWORD_SUCCESS,
  CREATE_USER_ROLE,
  CREATE_USER_ROLE_ERROR,
  CREATE_USER_ROLE_SUCCESS,
  DELETE_USER_ROLE,
  DELETE_USER_ROLE_ERROR,
  DELETE_USER_ROLE_SUCCESS,
  GET_USER_ROLES,
  GET_USER_ROLES_ERROR,
  GET_USER_ROLES_SUCCESS,
  SET_USER_ROLES,
  SET_USER_ROLES_SUCCESS,
  SET_USER_ROLES_ERROR,
  UPDATE_USER,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_ERROR,
  SET_VALIDITY_RANGE_ENABLED,
  RESET_PASSWORD,
  SET_API_KEY,
  CLEAR_API_KEY,
  GET_USER_AUTHENTICATION_METHODS,
  GET_USER_AUTHENTICATION_METHODS_SUCCESS,
  GET_USER_AUTHENTICATION_METHODS_ERROR,
  DELETE_AUTHENTICATION_METHOD,
  DELETE_AUTHENTICATION_METHOD_ERROR,
  DELETE_AUTHENTICATION_METHOD_SUCCESS,
} from './constants'
import {
  INVITE_USER,
  INVITE_USER_ERROR,
  INVITE_USER_SUCCESS,
} from 'containers/Users/constants'

const mapUserRole = ({ customerCode, companyCode, name, id, ...rest }) =>
  new UserRoleRecord({
    ...rest,
    id,
    customerCode,
    companyCode,
    name,
  })

const initialState = fromJS({
  error: false,
  loading: false,
  entraActionLoading: false,
  entraActionError: undefined,
  validityRangeEnabled: undefined,
  userRoles: undefined,
  userId: undefined,
  apiKey: undefined,
  authenticationMethods: undefined,
})

function userReducer(state = initialState, action) {
  switch (action.type) {
    case INVITE_USER: {
      if (action.view !== 'user') return state
      return state
        .set('entraActionLoading', true)
        .set('entraActionError', false)
    }
    case INVITE_USER_ERROR: {
      const { error } = action
      if (error.view !== 'user') return state
      return state
        .set('entraActionLoading', false)
        .set('entraActionError', error)
    }

    case INVITE_USER_SUCCESS: {
      if (action.view !== 'user') return state
      return state.set(
        'entraActionLoading',
        false,
        'entraActionError',
        undefined
      )
    }

    case DELETE_AUTHENTICATION_METHOD:
    case GET_USER_AUTHENTICATION_METHODS:
      return state
        .set('entraActionLoading', true)
        .set('entraActionError', undefined)

    case UPDATE_USER:
      if (action.view !== 'user') return state
      return state.set('loading', true).set('error', false)

    case CREATE_USER_ROLE:
    case DELETE_USER_ROLE:
    case GET_USER_ROLES:
    case CHANGE_PASSWORD:
    case RESET_PASSWORD:
      return state.set('loading', true).set('error', false)
    case SET_USER_ROLES: {
      if (action.view !== 'user') return state
      return state.set('loading', true).set('error', false)
    }
    case CHANGE_PASSWORD_SUCCESS:
      return state.set('loading', false)

    case UPDATE_USER_SUCCESS:
      if (action.view !== 'user') return state
      return state.set('loading', false)

    case SET_VALIDITY_RANGE_ENABLED:
      return state.set('validityRangeEnabled', action.enabled)

    case DELETE_USER_ROLE_SUCCESS:
      return state
        .set('loading', false)
        .set(
          'userRoles',
          state
            .get('userRoles')
            .filter((userRole) => userRole.id !== action.userRole.id)
        )

    case SET_USER_ROLES_SUCCESS: {
      const userRoles =
        action.view === 'user' ? action.roles.map(mapUserRole) : undefined
      return state
        .set('loading', false)
        .set('showCreateUserRoleForm', false)
        .set('userRoles', List(userRoles))
    }

    case CREATE_USER_ROLE_SUCCESS:
      const hasRoles = state.get('userRoles')
      return state
        .set('loading', false)
        .set('showCreateUserRoleForm', false)
        .set(
          'userRoles',
          hasRoles
            ? state.get('userRoles').push(UserRoleRecord(action.userRole))
            : List([UserRoleRecord(action.userRole)])
        )

    case DELETE_AUTHENTICATION_METHOD_SUCCESS:
      return state
        .set('entraActionLoading', false)
        .set('entraActionError', undefined)
        .set(
          'authenticationMethods',
          state.get('authenticationMethods')?.filter
            ? state
                .get('authenticationMethods')
                .filter((method) => method.id !== action.id)
            : undefined
        )

    case GET_USER_AUTHENTICATION_METHODS_SUCCESS:
      return state
        .set('entraActionLoading', false)
        .set('entraActionError', undefined)
        .set('authenticationMethods', action.authenticationMethods)

    case GET_USER_ROLES_SUCCESS:
      return state
        .set('loading', false)
        .set('userRoles', List(action.userRoles.map(mapUserRole)))
        .set('userId', action.userId)

    case GET_USER_AUTHENTICATION_METHODS_ERROR:
    case DELETE_AUTHENTICATION_METHOD_ERROR:
      return state
        .set('entraActionLoading', false)
        .set('entraActionError', action.error)

    case UPDATE_USER_ERROR:
      const { error } = action
      if (error.view !== 'user') return state
      return state.set('loading', false).set('error', error)

    case CREATE_USER_ROLE_ERROR:
    case DELETE_USER_ROLE_ERROR:
    case GET_USER_ROLES_ERROR:
    case CHANGE_PASSWORD_ERROR:
      return state.set('loading', false).set('error', action.error)
    case SET_USER_ROLES_ERROR: {
      const { error } = action
      if (error.view !== 'user') return state
      return state.set('loading', false).set('error', error)
    }
    case SET_API_KEY:
      return state.set('apiKey', action.apiKey)

    case CLEAR_API_KEY:
      return state.set('apiKey', undefined)

    default:
      return state
  }
}

export default userReducer
